import { APP_CONFIG } from "config/appConfig";
import { IAuthenticationStrategy, AuthProvider } from "./authenticationTypes";
import { CognitoAuthStrategy } from "./strategies/cognitoAuthStrategy";
import { LocalAuthStrategy } from "./strategies/localAuthStrategy";

export class AuthenticationFactory {
    private static instance: IAuthenticationStrategy | null = null;

    static getAuthenticationService(): IAuthenticationStrategy {
        this.instance ??= this.createAuthenticationService();

        return this.instance;
    }

    static createAuthenticationService(): IAuthenticationStrategy {
        const authProvider = this.getAuthProvider();

        switch (authProvider) {
            case AuthProvider.COGNITO:
                return new CognitoAuthStrategy();
            case AuthProvider.LOCAL:
                return new LocalAuthStrategy();
            case AuthProvider.KEYCLOAK:
                return new LocalAuthStrategy(); // Set Local AuthStrategy for Keycloak for temp
            default:
                throw new Error(
                    `Unsupported authentication provider: ${authProvider}`
                );
        }
    }

    static getAuthProvider(): AuthProvider {
        // Priority: Environment variable > default to COGNITO
        const provider = APP_CONFIG.APP_AUTH_PROVIDER?.toLowerCase();

        if (provider === "local") {
            return AuthProvider.LOCAL;
        }

        if (provider === "cognito") {
            return AuthProvider.COGNITO;
        }

        if (provider === "keycloak") {
            return AuthProvider.KEYCLOAK;
        }

        // Default fallback - check if Cognito credentials exist
        const hasAwsConfig =
            APP_CONFIG.APP_AWS_POOL_ID &&
            APP_CONFIG.APP_AWS_CLIENT_ID;

        return hasAwsConfig ? AuthProvider.COGNITO : AuthProvider.LOCAL;
    }

    static getCurrentProvider(): AuthProvider {
        return this.getAuthProvider();
    }

    static resetInstance(): void {
        this.instance = null;
    }
}
